// Shared notification grouping (2026-10-05) — used by the full Notifications
// page (tabs) AND the navbar bell popover (compact dropdown), so both always
// classify identically.
//
// Groups: All / Interpretations / Translations / Reminders / Tags.
// Classification is case-insensitive on Type; deadline alerts carry the
// service category in their metadata (Translation → Translations; Other-
// service alerts have no dedicated tab and stay under All).
export const NOTIFICATION_TABS = [
  { key: "all", label: "All" },
  { key: "interpretations", label: "Interpretations" },
  { key: "translations", label: "Translations" },
  { key: "reminders", label: "Reminders" },
  { key: "tags", label: "Tags" },
];

// Metadata arrives as an object from the REST API, but socket payloads and
// older rows can carry a JSON string — accept both.
const parseMetadata = (metadata) => {
  if (!metadata) return {};
  if (typeof metadata === "object") return metadata;
  if (typeof metadata === "string") {
    try {
      return JSON.parse(metadata);
    } catch {
      return {};
    }
  }
  return {};
};

export const getNotificationGroupKey = (notification) => {
  const type = String(notification?.Type || "").toLowerCase();
  const metadata = parseMetadata(notification?.Metadata);
  const category = String(
    metadata?.serviceCategory || metadata?.ServiceCategory || "",
  ).toLowerCase();

  if (type === "mention") return "tags";
  if (type === "reminder_watch") return "reminders";
  if (type.includes("interpretation")) return "interpretations";
  if (type.includes("deadline")) {
    return category === "translation" ? "translations" : null;
  }
  return null;
};
